module.exports = __webpack_public_path__ + "img/zy.48068a1e.png";